import { Button } from "@mui/material";
import { Checkbox, DatePicker, Input, InputNumber } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

const InHouseScheduleBox = (props) => {
    const { index } = props;
    const {
        control,
        trigger,
        formState: { errors },
        reset,
        getFieldState,
        setValue,
        watch,
        getValues,

    } = useFormContext();
    const viewMode = watch(`Schedule.[${index}].view`);
    const minLoan = watch(`Schedule.[${index}].minimum_loan_amount`);
    const maxLoan = watch(`Schedule.[${index}].maximum_loan_amount`);
    const checkVal =
        watch(`Schedule.[${index}].check_val`) === undefined
            ? "0"
            : watch(`Schedule.[${index}].check_val`);
    const postData = {
        interest: getValues(`Schedule.[${index}].interest`),
        startDate: getValues(`Schedule.[${index}].startDate`)
            ? dayjs(getValues(`Schedule.[${index}].startDate`)).format("DD MMM YYYY")
            : null,
        endDate: getValues(`Schedule.[${index}].endDate`)
            ? dayjs(getValues(`Schedule.[${index}].endDate`)).format("DD MMM YYYY")
            : "Further Notice",
        scheduleDate: getValues(`Schedule.[${index}].scheduleDate`)
            ? dayjs(getValues(`Schedule.[${index}].scheduleDate`)).format(
                "DD MMM YYYY HH:mm"
            )
            : null,
        remarks1: getValues(`Schedule.[${index}].remarks1`),
        remarks2: getValues(`Schedule.[${index}].remarks2`),
    };
    const saveInterestData = async () => {
        await trigger("Schedule", { shouldFocus: true });
        setTimeout(() => {
            const formData = getFieldState("Schedule");
            const { error } = formData;
            //console.log("formData", formData, errors)
            if (Object.keys(errors)?.length == 0) {
                setValue(`Schedule.[${index}].view`, true);
            }
        }, 1000);

    };
    const editData = () => {
        setValue(`Schedule.[${index}].view`, false);
    };
    const delData = () => {
        const { Schedule, ...restValues } = getValues();
        Schedule[index] = {
            interest: "",
            startDate: "",
            endDate: "",
            remarks1: "",
            remarks2: "",
            minimum_loan_amount: "",
            maximum_loan_amount: "",
            view: false,
        };
        reset({
            ...restValues,
            Schedule: Schedule,
        });
    };
    return (
        <div className="p-[25px] bg-[#F9FBFD] ">
            {viewMode ? (
                <div>
                    <div className="flex items-center gap-[10px_20px] mb-[15px] max-[600px]:flex-wrap">
                        <div className="w-[80px]">
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Interest Rate
                            </label>
                            <p className="text-[13px] min-h-[20px]">{postData.interest}%</p>
                        </div>
                        <div>
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Publish Date
                            </label>
                            <p className="text-[13px] min-h-[20px]">{postData.startDate}</p>
                        </div>
                        <span className="text-[13px] mt-[27px] inline-block max-[600px]:w-full max-[600px]:mt-[2px]">
                            To
                        </span>
                        <div>
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                End Date
                            </label>
                            <p className="text-[13px] min-h-[20px]">{postData.endDate}</p>
                        </div>
                    </div>
                    <div className="mb-[15px]">
                        <label className="block text-[13px] text-[#495159] mb-[6px]">
                            Schedule At
                        </label>
                        <p className="text-[13px] min-h-[20px]">{postData.scheduleDate}</p>
                    </div>
                    <div className="mb-[15px]">
                        <label className="block text-[13px] text-[#495159] mb-[6px]">
                            Remarks 1
                        </label>
                        <p className="text-[13px] min-h-[20px]">{postData.remarks1}</p>
                    </div>
                    <div className="mb-[15px]">
                        <label className="block text-[13px] text-[#495159] mb-[6px]">
                            Remarks 2{" "}
                        </label>
                        <p className="text-[13px] min-h-[20px]">{postData.remarks2}</p>
                    </div>
                    <div className="flex items-center gap-[10px] mb-[25px] max-[600px]:flex-wrap">
                        <div className="w-[152px]">
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Min. Loan Criteria
                            </label>
                            <p className="text-[13px] min-h-[20px]">
                                {minLoan && `$${minLoan}`}
                            </p>
                        </div>
                        <div className="w-[170px]">
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Else + Admin Fee
                            </label>
                            <p className="text-[13px] min-h-[20px]">
                                {maxLoan && `$${maxLoan}`}
                            </p>
                        </div>
                        <div>
                            <label className="block text-[13px] text-[#495159] mb-[6px] relative">
                                Statement Preview
                            </label>
                            <div className="min-h-[20px] pl-[5px]">
                                {(minLoan || maxLoan) && (
                                    <p className="text-[13px] font-[500]">
                                        {minLoan && `Min. Loan $${minLoan}`}
                                        {maxLoan && ` else + $${maxLoan} admin fee`}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Button
                            type="button"
                            className="sav_btn edit_btn"
                            onClick={editData}
                        >
                            Edit
                        </Button>
                        <Button type="button" className="sav_btn del_btn" onClick={delData}>
                            Delete
                        </Button>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="flex items-center gap-[10px] mb-[15px] max-[600px]:flex-wrap">
                        <div className="w-[80px]">
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Interest Rate
                            </label>
                            <Controller
                                control={control}
                                name={`Schedule.[${index}].interest`}
                                rules={{
                                    required: true,
                                }}
                                render={({ field, fieldState }) => {
                                    return (
                                        <InputNumber
                                            {...field}
                                            step="0.01"
                                            precision={2}
                                            type="number"
                                            status={fieldState.error ? "error" : null}
                                            prefix="%"
                                            placeholder="0"
                                            className="inhouseNum percent"
                                        />
                                    );
                                }}
                            />
                        </div>
                        <div>
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Publish Date
                            </label>
                            <Controller
                                control={control}
                                name={`Schedule.[${index}].startDate`}
                                rules={{
                                    required: true,
                                }}
                                render={({ field, fieldState }) => {
                                    return (
                                        <DatePicker
                                            {...field}
                                            status={fieldState.error ? "error" : null}
                                            placeholder="DD-MM-YYYY"
                                            format="DD-MM-YYYY"
                                            className="py-[8px]"
                                            disabledDate={(d) =>
                                                d.isBefore(dayjs().subtract(1, 'days'))
                                            }
                                            onChange={(date) => {
                                               // console.log("DARRRRTEEE", date)
                                                setValue(`Schedule.[${index}].startDate`, date);
                                                setValue(`Schedule.[${index}].endDate`, "")
                                            }}
                                        />
                                    );
                                }}
                            />
                        </div>
                        <span className="text-[13px] mt-[24px] inline-block max-[600px]:w-full max-[600px]:mt-[4px]">
                            To
                        </span>
                        <div>
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                End Date
                            </label>
                            <Controller
                                control={control}
                                name={`Schedule.[${index}].endDate`}
                                render={({ field }) => {
                                    return (
                                        <DatePicker
                                            {...field}
                                            placeholder="DD-MM-YYYY"
                                            format="DD-MM-YYYY"
                                            className="py-[8px]"
                                            disabledDate={(d) =>
                                                d.isBefore(dayjs(watch(`Schedule.[${index}].endDate`)))
                                            }
                                        />
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div className="mb-[15px]">
                        <label className="block text-[13px] text-[#495159] mb-[6px]">
                            Schedule At
                        </label>
                        <Controller
                            control={control}
                            name={`Schedule.[${index}].scheduleDate`}
                            rules={{
                                required: true,
                            }}
                            render={({ field, fieldState }) => {
                                return (
                                    <DatePicker
                                        {...field}
                                        showTime
                                        minuteStep={60}
                                        status={fieldState.error ? "error" : null}
                                        placeholder="DD-MM-YYYY HH:MM"
                                        format="DD-MM-YYYY HH:mm"
                                        className="py-[8px]"
                                        value={field.value ? dayjs(field.value).minute(0) : null}
                                        onChange={(date) => {
                                            field.onChange(date ? date.valueOf() : null);
                                        }}
                                        onOk={(date) => {
                                            field.onChange(date ? date.valueOf() : null);
                                        }}
                                        disabledDate={(d) =>
                                            d.isBefore(dayjs().subtract(1, 'days'))
                                        }

                                    />
                                );
                            }}
                        />
                    </div>
                    <div className="mb-[15px]">
                        <label className="block text-[13px] text-[#495159] mb-[6px]">
                            Remarks 1
                        </label>
                        <Controller
                            control={control}
                            name={`Schedule.[${index}].remarks1`}
                            rules={{
                                required: true,
                            }}
                            render={({ field, fieldState }) => {
                                return (
                                    <Input
                                        {...field}
                                        status={fieldState.error ? "error" : null}
                                        placeholder="Remarks 1"
                                        className="py-[8px]"
                                    />
                                );
                            }}
                        />
                    </div>
                    <div className="mb-[15px]">
                        <label className="block text-[13px] text-[#495159] mb-[6px]">
                            Remarks 2{" "}
                        </label>
                        <Controller
                            control={control}
                            name={`Schedule.[${index}].remarks2`}
                            render={({ field }) => {
                                return (
                                    <Input
                                        {...field}
                                        placeholder="Remarks 2"
                                        className="py-[8px]"
                                    />
                                );
                            }}
                        />
                    </div>
                    <div className="flex items-center gap-[10px] mb-[25px] max-[600px]:flex-wrap">
                        <div className="w-[152px]">
                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                Min. Loan Criteria
                            </label>
                            <Controller
                                control={control}
                                name={`Schedule.[${index}].minimum_loan_amount`}
                                rules={{
                                    required: true,
                                }}
                                render={({ field, fieldState }) => {
                                    return (
                                        <InputNumber
                                            {...field}
                                            step="0.01"
                                            precision={2}
                                            type="number"
                                            status={fieldState.error ? "error" : null}
                                            prefix="$"
                                            placeholder="0.00"
                                            className="inhouseNum"
                                        />
                                    );
                                }}
                            />
                        </div>
                        <div className="w-[170px]">
                            <label className="block text-[13px] text-[#495159] mb-[6px] pl-[25px] max-[417px]:pl-[0]">
                                Else + Admin Fee
                            </label>
                            <div className="flex items-center">
                                <Checkbox
                                    className="mr-[10px]"
                                    checked={checkVal === "1"}
                                    onChange={() =>
                                        setValue(
                                            `Schedule.[${index}].check_val`,
                                            checkVal === "0" ? "1" : "0"
                                        )
                                    }
                                />
                                <Controller
                                    control={control}
                                    name={`Schedule.[${index}].maximum_loan_amount`}
                                    rules={{
                                        required: checkVal === "1" ? true : false,
                                    }}
                                    render={({ field, fieldState }) => {
                                        return (
                                            <InputNumber
                                                {...field}
                                                step="0.01"
                                                precision={2}
                                                type="number"
                                                status={fieldState.error ? "error" : null}
                                                prefix="$"
                                                placeholder="0.00"
                                                className="inhouseNum"
                                                disabled={checkVal === "0"}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="max-[600px]:w-full">
                            <label className="block text-[13px] text-[#495159] mb-[6px] relative bottom-[10px] max-[600px]:bottom-[0]">
                                Statement Preview
                            </label>
                            <div className="min-h-[20px] pl-[5px]">
                                {(minLoan || maxLoan) && (
                                    <p className="text-[13px] font-[500]">
                                        {minLoan && `Min. Loan $${minLoan}`}
                                        {maxLoan && ` else + $${maxLoan} admin fee`}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Button
                            type="button"
                            className="sav_btn"
                            onClick={saveInterestData}
                        >
                            Save Changes
                        </Button>
                        {/* <Button type="button" className="can_btn">Cancel</Button> */}
                    </div>
                </div>
            )}
        </div>
    );
};

export default InHouseScheduleBox;
